import React, {Component} from "react"

import {BasketItemType, Product, Deal} from "@irati/types"
import {H1} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import basket from "@irati/checkout/utils/basket"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import LimitWrapper from "./shared/LimitWrapper"
import QuantityContainer from "./shared/Quantity/QuantityContainer"
import {QuantityOnChange} from "./shared/Quantity/QuantityItem"

interface Props extends WithPerkOrReward {
  deal: Deal
  products: Product[]
}

class MultipleProducts extends Component<Props> {
  handleUpdateQuantity: QuantityOnChange = (type, productId) => {
    const {deal, isRewards} = this.props
    let count = basket.items.find((t) => t.productId === productId)?.count || 0
    if (type === "+") {
      count++
    } else {
      count--
    }
    const entityType = isRewards ? BasketItemType.FlexiReward : BasketItemType.Deal
    basket.setProduct(entityType, deal.uuid, productId, {count})
  }

  render() {
    const {deal, products} = this.props
    return (
      <div className="multipleProductSelection">
        <H1 marginBottom={2}>
          <FormattedMessage id="perks.components.productForms.multipleProductSelection.selectText" />
        </H1>

        <div className="quantityList">
          <LimitWrapper deal={deal}>
            <QuantityContainer deal={deal} products={products} handleClick={this.handleUpdateQuantity} />
          </LimitWrapper>
        </div>
      </div>
    )
  }
}

export default withPerkOrReward(MultipleProducts)
